import { formatAppliedFilters, extractTextFromValue } from './core'

export const exportGridToCSV = (options = {}) => {
  const filename = options.filename || 'relatorio_dados.csv';
  const columnsList = options.columns || [];
  const dataResult = options.filteredData || [];

  const exportColumns = columnsList.filter((col) =>
    col.Export !== 'False' && col.Export !== false
  );

  const headers = exportColumns.map((col) => col.header).join(',');
  const rows = dataResult.map((row) => {
    return exportColumns
      .map((col) => {
        let value = extractTextFromValue(row[col.field]);
        if (typeof value === 'string') {
          if (value.length > 32000) value = value.substring(0, 32000) + '...';
          if (value.includes(',') || value.includes('"') || value.includes('\n')) {
            return '"' + value.replace(/"/g, '""') + '"';
          }
        }
        return value;
      })
      .join(',');
  });

  // Adicionar filtros no início se existirem
  let csvRows = [headers, ...rows];
  const filtersText = formatAppliedFilters(options.appliedFilters);
  
  if (filtersText) {
    // Adicionar linha de filtros no topo
    const filterLine = `"Filtros aplicados: ${filtersText.replace(/"/g, '""')}"`;
    // Adicionar vírgulas para manter a estrutura de colunas
    const extraCommas = ','.repeat(exportColumns.length - 1);
    csvRows.unshift(filterLine + extraCommas);
    csvRows.splice(1, 0, ''); // Adicionar linha vazia após os filtros
  }

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default exportGridToCSV


